import Growth from './Components/Growth.tsx'; // Adjust the import path as necessary
import { useEffect, useState } from "react";
import VerifiedLeads from "./Components/VerifiedLeads.tsx";
import Inbox from "./Components/Inbox.tsx"; // Import the new Inbox component
import { actions as actions_BusinessLeadsSlice } from "../../../../state/BusinessLeadsSlice/BusinessLeadsSlice.tsx"
import { useBackend } from "../../../../hooks/backend/useBackend.ts";
import { RootState, useAppSelector } from "../../../../state/state.tsx";
import { selectEffectiveUID } from '../../../../state/UserStatesV2/userSliceV2.ts';

export default function Campaigns() {

    const [selectedTab, setSelectedTab] = useState<string>("1");

    // Loading BusinesssSlice

    const serviceProviderId = useAppSelector(selectEffectiveUID); 



    const { loadCollection } = useBackend(`/ServiceProviders/${serviceProviderId}/BusinessLeads`)

    useEffect(() => {
        if (serviceProviderId) {

            loadCollection(actions_BusinessLeadsSlice);
        }

    }, [serviceProviderId]);


    return (
        <div className={"p-5 "}>
            <div className={" inline-flex bg-cc_campaign_unselected_bg rounded-xl p-1.5 gap-4"}>
                <div onClick={() => {
                    setSelectedTab("1")
                }}
                    className={`cursor-pointer font-semibold text-lg py-2 px-5 ${selectedTab === "1" ? "text-black bg-white shadow-xl" : "text-[#798592]"}  rounded-xl `}>
                    Create Campaign
                </div>
                <div onClick={() => {
                    setSelectedTab("2")
                }}
                    className={`cursor-pointer font-semibold text-lg py-2 px-5 ${selectedTab === "2" ? "text-black bg-white shadow-xl" : "text-[#798592]"}  rounded-xl `}>
                    Campaign Stats
                </div>
                <div onClick={() => {
                    setSelectedTab("3")
                }}
                    className={`cursor-pointer font-semibold text-lg py-2 px-5 ${selectedTab === "3" ? "text-black bg-white shadow-xl" : "text-[#798592]"}  rounded-xl `}>
                    Past Campaigns
                </div>

            </div>

            <div className={"mt-8 "}>
                ̥


                {selectedTab === "1" && <Growth />}
                {selectedTab === "2" && <VerifiedLeads />}
                {selectedTab === "3" && <Inbox />}
                {/*<Inbox/>*/}


            </div>

        </div>
    );
}

